import React from 'react';

// Components
import {Gateway} from '@doorson/doorson-app';

const App = () => <Gateway appListUrl={process.env.REACT_APP_LIST} />;

export default App;
